const hasWindow = typeof window !== "undefined";
const hasProcess = typeof process !== "undefined";

const isProd =
  hasProcess &&
  process.env &&
  process.env.NODE_ENV === "production";

function isDebugEnabled() {
  if (!hasWindow || !window.localStorage) {
    return false;
  }

  if (window.__APP_DEBUG__ === true) {
    return true;
  }

  return window.localStorage.getItem("app_debug") === "1";
}

function canEmitNonErrorLogs() {
  return !isProd || isDebugEnabled();
}

function write(method, args) {
  if (typeof console === "undefined" || typeof console[method] !== "function") {
    return;
  }
  console[method](...args);
}

const logger = {
  error(...args) {
    write("error", args);
  },
  warn(...args) {
    if (canEmitNonErrorLogs()) {
      write("warn", args);
    }
  },
  info(...args) {
    if (canEmitNonErrorLogs()) {
      write("info", args);
    }
  },
  debug(...args) {
    if (canEmitNonErrorLogs()) {
      write("debug", args);
    }
  },
  log(...args) {
    if (canEmitNonErrorLogs()) {
      write("log", args);
    }
  }
};

export function setRuntimeDebug(enabled) {
  if (!hasWindow || !window.localStorage) {
    return;
  }

  window.localStorage.setItem("app_debug", enabled ? "1" : "0");
}

export default logger;



// WEBPACK FOOTER //
// ./src/utils/logger.js